<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>网站配置</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item to="/config/menus">角色管理</el-breadcrumb-item>
        <el-breadcrumb-item>角色管理列表</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>角色管理列表</span>
        </div>
        <el-button  @click="dialogFormVisible = true" size="small" icon="el-icon-plus" type="primary">添加角色</el-button>
      </div>
      <div class="xcx-content">
        <!--列表-->
        <el-table border :data="tableData" style="width: 100%" row-key="id" v-loading="loading" default-expand-all :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <!-- <el-table-column prop="role_id" label="角色ID" width="100"></el-table-column> -->
          <el-table-column prop="role_name" label="角色名称" width="200"></el-table-column>
          <el-table-column prop="memo" label="角色描述" width="160"></el-table-column>
          <el-table-column></el-table-column>
          <el-table-column prop="utime" label="修改时间" width="180"></el-table-column>
          <el-table-column label="操作" width="210">
            <template #default="scope">
              <el-button size="mini" type="success" @click="openQx(scope.row.role_id)">权限</el-button>
              <el-button size="mini" @click="edit(scope.row.role_id)">编辑</el-button>
              <el-button size="mini" type="danger" @click="del_item(scope.row.role_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <div class="paging">
          <el-pagination class="left" @current-change="handleCurrentChange" :current-page="page" background layout="prev, pager, next" :total="count"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加角色 -->
    <el-dialog title="角色管理" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="角色名称" :label-width="formLabelWidth" prop="role_name">
          <el-input v-model="ruleForm.role_name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="角色描述" :label-width="formLabelWidth">
          <el-input v-model="ruleForm.memo" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="权限管理" :visible.sync="dialogFormMeaus">
      <el-tree ref="tree" :data="dataList" show-checkbox node-key="menu_id" :default-checked-keys="checkedKeys" :props="defaultProps">
      </el-tree>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormMeaus = false">取 消</el-button>
        <el-button type="primary" @click="submitMeausList">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import UploadOne from "../../components/upload/UploadOne";
export default {
  components: {
    UploadOne,
  },
  data() {
    return {
      loading: true,
      id: "",
      tableData: [],
      cateList: [],
      page: 1,
      count: 0,
      limit: 10,
      dialogFormVisible: false,
      dialogFormMeaus: false,
      ruleForm: {
        role_name: "",
        branch_id: "",
        memo: "",
      },
      dataList: [],
      treeKeys: [],
      checkedKeys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      rules: {
        role_name: [
          { required: true, message: "请填写角色名称", trigger: "change" },
        ],
      },
      formLabelWidth: "120px",
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    that.getList();
    //that.getCate();
  },
  methods: {
    // 获取勾选的角色
    getCheckedKeys() {
      var that = this;
      that.treeKeys = that.$refs.tree.getCheckedKeys();
      console.log(that.treeKeys);
    },

    submitMeausList() {
      var that = this;
      that.getCheckedKeys();
      var formMeausList = {};
      formMeausList.role_id = that.id;
      formMeausList.menu_id = that.treeKeys.join(",");
      console.log(formMeausList);
      that.axios.post("/role/setRoleMenu", formMeausList).then((res) => {
        that.$message.success(res.msg);
      });
      that.dialogFormMeaus = false;
      that.treeKeys = [];
    },

    openQx(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/role/getAllRole", { id: ids }).then((res) => {
        if (res) {
          that.dataList = res.data.meau;
          that.treeKeys = res.data.qx;
          that.checkedKeys = res.data.qx;
          that.dialogFormMeaus = true;
        }
      });
    },

    edit(ids) {
      var that = this;
      that.id = ids;
      that.axios.post("/role/edit", { id: ids }).then((res) => {
        if (res) {
          that.ruleForm = res.data;
          that.dialogFormVisible = true;
        }
      });
    },
    /**
     * 下一页
     */
    handleCurrentChange(currentPage) {
      var that = this;
      that.page = currentPage;
      that.getList();
    },

    del_item(ids) {
      let that = this;
      this.$confirm("此操作不可逆, 是否继续?", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        that.axios
          .post("/role/del", {
            role_id: ids,
          })
          .then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              that.getList();
            } else {
              this.$message({
                type: "info",
                message: res.msg,
              });
            }
          });
      });
    },
    /**
     * 获取列表
     */
    getList() {
      let that = this;
      let formData = {};
      var curr_page = sessionStorage.getItem("curr_page");
      that.page = curr_page ? curr_page - 0 : that.page;
      formData.pageNum = that.page;
      formData.pageSize = that.limit;
      that.axios.post("/role/index", formData).then((res) => {
        if (res) {
          console.log(res);
          that.tableData = res.data.data;
          that.count = res.data.total;
          that.page = curr_page ? curr_page : that.page;
          curr_page ? sessionStorage.removeItem("curr_page") : "";
        }
        that.loading = false;
      });
    },
    /**
     * 提交信息
     */
    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        var url = "/role/add";
        if (that.id) {
          formData.role_id = that.id;
          url = "/role/edit";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.ruleForm.pid = "";
          that.ruleForm.thumb = "";
          that.ruleForm.zh_title = "";
          that.ruleForm.en_title = "";
          that.ruleForm.sort = "";
          that.dialogFormVisible = false;
          that.getList();
        });
      });
    },
  },
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}
</style>